(function () {
  window.onbeforeprint = function (ev) {
    ev.preventDefault();

    $("img.lazyloaded").each(function(){
        $(this).trigger('appear');
    });
  }
  
})();